<button
  mat-icon-button
  class="send-button recording-button"
  type="button"
  *ngIf="visible"
  [disabled]="disabled"
  [ngClass]="{ pulsate: isRecording }"
  matTooltip="Use Voice"
  matTooltipPosition="below"
  (pointerdown)="startRecording()"
  (pointerup)="stopRecording()"
  (pointerleave)="stopRecording()"
  (contextmenu)="disableRightClick($event)"
>
  <mat-icon>{{ recordingIcon }}</mat-icon>
</button>